import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import Api from '../../../../Global/Modules/Api'

const FETCH_URL = 'api/members/'
class BeoordelingsDocumentUploadEdit extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            assestment: {
                comments: ''
            },
            errors: {}
        }

    }

    componentWillMount() {
        const FETCH_URL_Edit = `api/members/${this.props.id}/assestment`
        Api.GetApi(FETCH_URL_Edit).then(data => {
            this.setState({ assestment: data.result })
        });
    }
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ assestment: { ...this.state.assestment, [name]: value } })
    }
    handleSubmit(event) {
        event.preventDefault()
        var fdata = { 'description': this.state.assestment.comments, 'id': this.props.id };
        // TODO: Post payload to the API
        Api.PostApi(FETCH_URL + "assestment", fdata, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    Api.print(response)
                    this.setState({ errors: response });
                }
                else {
                    alert("Document updated")
                    window.location.href = "/admin/leden/lid/beoordelingsdocumenten/" + this.state.assestment.memberId
                }
            })
    }
    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="BeoordelingsDocumentOpmerking">
                    <Col componentClass={ControlLabel} sm={4}>
                        Opmerking
                    </Col>
                    <Col sm={6}>
                        <FormControl name="comments" type="text" required value={this.state.assestment.comments} onChange={this.handleChange} />
                        {Api.showError(errors, "comments")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default BeoordelingsDocumentUploadEdit;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/BeoordelingsDocumentenEdit.js